import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Injectable } from "@angular/core";
import { switchMap, map } from 'rxjs/operators';
import { CompanyData } from './../base-models/company-data';
import { Observable, forkJoin, of } from 'rxjs';
import { CommonService } from './common.service';

@Injectable({
    providedIn: 'root'
})
export class CompanyDataService {
    constructor(
        protected configService: ConfigService,
        protected httpClient: HttpClient
    ){
    }

    GetByTaxNo(taxNo: string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient
                    .get(config + 'api/CompanyData/GetByTaxIDNumber?taxIdNo=' + taxNo)
                        .pipe(map((data: CompanyData[]) => {
                            const items: CompanyData[] = data ? data.map(item => {
                                return (new CompanyData().Deserialize(item));
                            }) : [];
                            return items;
                        })
                    )
            }))
    }

    GetByNationalIdentificationNo(nationalIdentificationNo: string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient
                    .get(config + 'api/CompanyData/GetByNationalIDNumber?nationalIDNo=' + nationalIdentificationNo)
                        .pipe(map((data: CompanyData[]) => {
                            const items: CompanyData[] = data ? data.map(item => {
                                return (new CompanyData().Deserialize(item));
                            }) : [];
                            return items;
                        }))
            }))
    }

    GetAccountDataByTaxNo(taxNo: string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient
                    .get(config + 'api/CompanyAccountData/GetByTaxIDNumber?taxIDNo=' + taxNo)
                        .pipe(map((data: any) => {
                            return data || [];
                        }))
            }))
    }

    GetCompanyDataByTaxNo(taxNo: string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {                    
                return forkJoin(this.httpClient.get(config + 'api/CompanyData/GetByTaxIDNumber?taxIdNo=' + taxNo),
                                this.httpClient.get(config + 'api/CompanyAccountData/GetByTaxIDNumber?taxIDNo=' + taxNo))
                .pipe(switchMap(([companyData, companyAccountData]: [CompanyData[], CompanyData[]]) => {
                    if((companyData != null && companyData.length > 0) || (companyAccountData != null && companyAccountData.length > 0)){
                    const items: CompanyData[] = [];
                    if (companyData.length == 0 && companyAccountData.length > 0)
                    {                        
                        companyData[0] = new CompanyData().Deserialize(companyAccountData[0]);
                    }
                        
                    companyData[0].AccountNumbers = [];
                    companyAccountData.forEach(companyAccountItem => {
                        let companyAccount : string = companyAccountItem['CompanyAccount']
                        let companyAccountArray = companyAccount.split('-');
                        let companyAccount1 : string = companyAccountArray[0];
                        let companyAccount2 : string = companyAccountArray[1];
                        let companyAccount3 : string = new CommonService().PadLeft(companyAccountArray[2],"0",2).trim();
                        companyData[0].AccountNumbers.push(companyAccount1 + "-" + companyAccount2 + "-" + companyAccount3);                  
                    })

                    return this.GetMestoIDByNaziv(companyData[0].PostalCode, companyData[0].City)
                        .pipe(map((data: string) => {
                            companyData[0]["CityID"] = data;

                            return companyData;
                        }))
                    }
                    else{
                        return of(companyData);
                    }
                }))
            }))
    }


    GetCompanyDataByNationalIdentificationNo(nationalIdentificationNo: string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {               
                    return forkJoin(this.httpClient.get(config + 'api/CompanyData/GetByNationalIDNumber?nationalIDNo=' + nationalIdentificationNo),
                                    this.httpClient.get(config + 'api/CompanyAccountData/GetByNationalIDNumber?nationalIDNo=' + nationalIdentificationNo))
                        .pipe(switchMap(([companyData, companyAccountData]: [CompanyData[], CompanyData[]]) => {
                            if((companyData != null && companyData.length > 0) || (companyAccountData != null && companyAccountData.length > 0)){
                                let items : CompanyData[];
                                if (companyData != null && companyData.length > 0){
                                    items = companyData.map((item: CompanyData) => {
                                        let companyDataItem = new CompanyData().Deserialize(item);
                                        companyDataItem.AccountNumbers = [];
                                        companyAccountData.forEach(companyAccountItem => {
                                            let companyAccount : string = companyAccountItem['CompanyAccount']
                                            let companyAccountArray = companyAccount.split('-');
                                            let companyAccount1 : string = companyAccountArray[0];
                                            let companyAccount2 : string = companyAccountArray[1];
                                            let companyAccount3 : string = new CommonService().PadLeft(companyAccountArray[2],"0",2).trim();
                                            companyDataItem.AccountNumbers.push(companyAccount1 + "-" + companyAccount2 + "-" + companyAccount3);
                                        })
                                        if ((companyDataItem.TaxIdentificationNumber == "" || companyDataItem.TaxIdentificationNumber == null) && (companyAccountData != null && companyAccountData[0].TaxIdentificationNumber != ""))
                                            companyDataItem.TaxIdentificationNumber = companyAccountData[0].TaxIdentificationNumber;
                                        return companyDataItem;
                                    })
                                }
                                else{
                                    if (companyAccountData != null && companyAccountData.length > 0){
                                    items = companyAccountData.map((item: CompanyData) => {
                                        let companyDataItem = new CompanyData().Deserialize(item);
                                        companyDataItem.AccountNumbers = [];
                                        companyAccountData.forEach(companyAccountItem => {
                                            let companyAccount : string = companyAccountItem['CompanyAccount']
                                            let companyAccountArray = companyAccount.split('-');
                                            let companyAccount1 : string = companyAccountArray[0];
                                            let companyAccount2 : string = companyAccountArray[1];
                                            let companyAccount3 : string = new CommonService().PadLeft(companyAccountArray[2],"0",2).trim();
                                            companyDataItem.AccountNumbers.push(companyAccount1 + "-" + companyAccount2 + "-" + companyAccount3);
                                        })
                                        return companyDataItem;
                                        })
                                    }    
                                }

                                return this.GetMestoIDByNaziv(items[0].PostalCode, items[0].City)
                                    .pipe(map((data: string) => {
                                        items[0]["CityID"] = data;

                                        return items;
                                    }))
                            }
                            else{
                                return of(companyData);
                            }
                        }))
            }))
    }

    GetMestoIDByNaziv(postalCode: string, name: string){
        return this.configService.GetApiUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient.post(config + 'api/mesto/getIdByNaziv', { PostBroj: postalCode == '' || postalCode == null ? '0' : postalCode, Naziv: name, OpstinaID: -1 })
            }))
    }

    GetCompanyDataByAccountNumber(bankCode: string, accountNumber:string, controlNumber:string){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient.get(config + 'api/CompanyAccountData/GetByAccountNumber?bankCode=' + bankCode + '&accountNumber=' + accountNumber + '&controlNumber=' + controlNumber)
                        .pipe(map((companyData : CompanyData[]) => {
                            if(companyData != null && companyData.length > 0){
                                return companyData;
                            }
                            else{
                                return of(companyData);
                            }
                        }))
            }))
    }
}